import React from 'react';
import { connect } from 'react-redux';
import Overlay from '../components/uiOverlay/uiOverlay';
import PlayerState from '../PlayerState';
function UiOverlay(props) {
    return React.createElement(Overlay, Object.assign({}, props));
}
const mapStateToProps = state => ({
    modal: state.modal.modalType ? state.modal : false,
    hideElements: state.scene.sceneSettings.hideElements,
    playerPlaying: state.loading.playerState >= PlayerState.PLAYING,
    reverseHeaderLayout: state.scene.sceneSettings.reverseHeaderLayout,
    miniUi: state.layout.miniUi,
    hideUi: state.layout.hideUi,
});
export default connect(mapStateToProps)(UiOverlay);
